import React from 'react';
import type { BreadcrumbItemViewModel } from 'autogen/swagger/all';
import InlineButton from 'components/generic/InlineButton';
import InlineLinkActionButton from 'components/generic/InlineButton/InlineLinkActionButton';

export type BreadcrumbItemProps = {
    model: BreadcrumbItemViewModel;
};

export default function BreadcrumbItem(props: BreadcrumbItemProps) {
    const { model } = props;
    const { linkAction, name } = model;

    function handleTracking(e) {
        e.preventDefault();
        const element = e.target as HTMLAnchorElement;

        window.location.href = element.href;
    }

    if (!linkAction) {
        return (
            <InlineButton onClick={handleTracking} size="S" variant="secondary">
                {name}
            </InlineButton>
        );
    }

    return (
        <InlineLinkActionButton action={linkAction} onClick={handleTracking} size="S" variant="secondary">
            {name}
        </InlineLinkActionButton>
    );
}
